export default {
  state: {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : ''
  },
  mutations: {
    changeLogin(state, user) {
      state.token = user.token;
    }
  }
}